module.exports = __webpack_public_path__ + "static/media/1-_DSC9412.0c9f0461.jpg";